
export function sizingStyles(size: number) {
	return `flex: ${size} 0 0;`
}

